module.exports = __webpack_public_path__ + "static/media/work_1.b9246383.jpg";